import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../components/Footer';

export default function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <h1>Privacy Policy</h1>
        <p className="legal-effective">Effective Date: June 14, 2025</p>
      </section>

      <section className="legal-content">
        <div className="legal-inner">
          <h2>1. Introduction</h2>
          <p>
            Vector Labs LLC ("Vector Labs," "we," "us," or "our") is committed to protecting
            your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard
            your information when you visit our website at{' '}
            <a href="https://vectorlabsnc.com">vectorlabsnc.com</a>{' '}
            and use our services, including Wallet King and any other products
            (collectively, the "Services").
          </p>

          <h2>2. Information We Collect</h2>

          <h3>2.1 Information You Provide</h3>
          <ul>
            <li><strong>Account Information:</strong> When you sign in with Google, we receive your name, email address, and profile picture.</li>
            <li><strong>Beta Signup Information:</strong> When you sign up for product betas, we collect your email address and the product you expressed interest in.</li>
            <li><strong>Newsletter Subscriptions:</strong> Your email address when you subscribe to our engineering updates.</li>
            <li><strong>Consultation Requests:</strong> Name, email, company details, and project information you provide through our consulting forms.</li>
            <li><strong>Communications:</strong> Any messages, feedback, or other content you send to us.</li>
          </ul>

          <h3>2.2 Information Collected Automatically</h3>
          <ul>
            <li><strong>Usage Data:</strong> Pages visited, time spent on pages, links clicked, scroll depth, and navigation patterns.</li>
            <li><strong>Device Information:</strong> Browser type, operating system, device type, and screen resolution.</li>
            <li><strong>Referral Data:</strong> The website or source that referred you to our Services.</li>
          </ul>

          <h3>2.3 Information from Third Parties</h3>
          <ul>
            <li><strong>Google OAuth:</strong> When you sign in with Google, we receive profile information as authorized by your Google account settings.</li>
          </ul>

          <h2>3. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide, maintain, and improve our Services</li>
            <li>Send you beta invitations, product updates, and engineering newsletters you've opted into</li>
            <li>Respond to your inquiries and consultation requests</li>
            <li>Analyze usage patterns to improve user experience</li>
            <li>Track which articles you've read to provide personalized recommendations</li>
            <li>Detect, prevent, and address technical issues or abuse</li>
            <li>Comply with legal obligations</li>
          </ul>

          <h2>4. Subscriber Groups and CRM</h2>
          <p>
            When you sign up for a beta program or newsletter, we categorize your subscription
            into groups (e.g., "beta-searchup," "newsletter") to send you relevant updates.
            We track which articles you read on our blog to provide better recommendations.
            You can request to see or delete this data at any time by contacting us.
          </p>

          <h2>5. How We Share Your Information</h2>
          <p>We do not sell your personal information. We may share your information with:</p>
          <ul>
            <li><strong>Service Providers:</strong> Third-party companies that help us operate our Services (e.g., email delivery, cloud hosting, analytics).</li>
            <li><strong>Legal Requirements:</strong> When required by law, subpoena, or legal process.</li>
            <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets.</li>
            <li><strong>With Your Consent:</strong> When you have given us explicit permission.</li>
          </ul>

          <h2>6. Data Storage and Security</h2>
          <p>
            Your data is stored on secure servers. We use industry-standard security measures
            including encryption, access controls, and secure data transmission (HTTPS) to protect
            your information. However, no method of transmission over the Internet is 100% secure.
          </p>

          <h2>7. Your Rights and Choices</h2>
          <p>You have the right to:</p>
          <ul>
            <li><strong>Access:</strong> Request a copy of the personal data we hold about you.</li>
            <li><strong>Correction:</strong> Request correction of inaccurate information.</li>
            <li><strong>Deletion:</strong> Request deletion of your personal data.</li>
            <li><strong>Opt-Out:</strong> Unsubscribe from emails by replying "unsubscribe" or contacting us.</li>
            <li><strong>Data Portability:</strong> Request your data in a machine-readable format.</li>
          </ul>

          <h2>8. Cookies and Tracking</h2>
          <p>
            We use local storage to maintain your authentication session and preferences. Our
            analytics system tracks page views and interactions to improve the Services. You can
            clear your browser's local storage at any time.
          </p>

          <h2>9. Third-Party Services</h2>
          <p>Our Services may integrate with:</p>
          <ul>
            <li><strong>Google OAuth:</strong> For authentication. Subject to <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google's Privacy Policy</a>.</li>
            <li><strong>AWS:</strong> For file storage and hosting. Subject to <a href="https://aws.amazon.com/privacy/" target="_blank" rel="noopener noreferrer">AWS Privacy Policy</a>.</li>
            <li><strong>Vercel:</strong> For website hosting. Subject to <a href="https://vercel.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">Vercel's Privacy Policy</a>.</li>
          </ul>

          <h2>10. Children's Privacy</h2>
          <p>
            Our Services are not directed to individuals under the age of 13. We do not knowingly
            collect personal information from children under 13. If we learn that we have collected
            personal information from a child under 13, we will delete that information promptly.
          </p>

          <h2>11. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any changes
            by posting the new Privacy Policy on this page and updating the "Effective Date" above.
            Your continued use of the Services after changes constitutes acceptance of the updated policy.
          </p>

          <h2>12. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:
          </p>
          <ul>
            <li>Email: <a href="mailto:alvarezjd404@gmail.com">alvarezjd404@gmail.com</a></li>
            <li>Website: <a href="https://vectorlabsnc.com/consulting">vectorlabsnc.com/consulting</a></li>
          </ul>

          <div className="legal-nav">
            <Link to="/terms">Terms &amp; Conditions</Link>
            <Link to="/">Back to Home</Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
